import React, { useState } from 'react'
import { StaticImage as Img } from "gatsby-plugin-image";
import Hero from './style'
import { Col, Container, Row } from 'react-bootstrap';
import { Form, Link } from '~components'
import { navigate } from 'gatsby'
import { SuperTag } from '~components';
export default function HeroSection() {
  return (
    <Hero>
      <Container>
        <Row className="justify-content-center">
          <Col xs="12" className="col-xl-8 col-lg-11">
            <Hero.ContentBlock mb="40px">
              <Hero.Title as="h1">Save 90% of your time by turning documents into insights.</Hero.Title>
              <Hero.Text> <SuperTag value="DocPile is a secure document storage platform - combining documents with AI to optimise your existing distributed workflow in a single space." />
              </Hero.Text>
              <Hero.TitleShape>
                <Img className="w-100" src="../../../assets/image/project-management/l2-hero-shape.png" alt="projects" layout="fullWidth" placeholder="blurred" />
              </Hero.TitleShape>
            </Hero.ContentBlock>
            {/* Newsletter */}
            <Hero.NewsletterBox>
              <Hero.Newsletter>
                <Hero.InputBox>
                  <Hero.Button className=" btn btn-primary text-white" onClick={() => {
                    navigate(`/early-access`);
                  }}>Get Early Access</Hero.Button>
                </Hero.InputBox>
              </Hero.Newsletter>
            </Hero.NewsletterBox>
            {/*/ .Newsletter */}
          </Col>
          <Col xs="12" className="col-lg-5 col-md-7">
            <Hero.Image>
              <Img className="w-100" src="../../../assets/image/project-management/l2-hero-image.png" alt="content" placeholder="blurred" />
            </Hero.Image>
          </Col>
        </Row>
      </Container>
      <Hero.ImageShape01>
        <Img className="w-100" src="../../../assets/image/project-management/l2-hero-shape-2.png" alt="shape 2" placeholder="blurred" />
      </Hero.ImageShape01>
      <Hero.ImageShape02>
        <Img className="w-100" src="../../../assets/image/project-management/l2-hero-shape-1.png" alt="shape 1" placeholder="blurred" />
      </Hero.ImageShape02>
    </Hero>
  )
}